// extracted by mini-css-extract-plugin
export default {"container":"c_cksbqVE","serviceBox":"cMIiWF3eT","priceContainer":"cUCF8OSSo","price":"cCbQVHkT3","header":"cw3X1qDzp","newService":"cDwoRnGlr"};